module.exports = {"431172120":"金洞镇","431172201":"晒北滩瑶族乡","431172202":"凤凰乡","431172204":"石鼓源乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431172.json
// module id = 1915
// module chunks = 0